import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';
import { getAdminSettingsToolPath } from '../admin-tool-registry/admin-tool.registry';
import {
  AdminStatsSectionNav,
  AdminStatsSectionNavItem,
} from '../admin-stats-section-nav/admin-stats-section-nav';

@Component({
  selector: 'admin-tool-brand-vouchers',
  imports: [RouterOutlet, AdminStatsSectionNav],
  templateUrl: './brand-vouchers.html',
  host: { class: 'block h-full w-full min-h-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBrandVouchers {
  private readonly router = inject(Router);
  private readonly listPath = `${getAdminSettingsToolPath('brand-vouchers')}/list`;

  readonly navItems: AdminStatsSectionNavItem[] = [
    { label: 'New Voucher', route: `${getAdminSettingsToolPath('brand-vouchers')}/new` },
    { label: 'List', route: this.listPath },
  ];

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects.split('?')[0] ?? ''),
      startWith(this.router.url.split('?')[0] ?? ''),
    ),
    { initialValue: this.router.url.split('?')[0] ?? '' },
  );

  readonly isProfile = computed(() => this.currentUrl().startsWith(`${this.listPath}/`));

  backToList(): void {
    void this.router.navigate([getAdminSettingsToolPath('brand-vouchers'), 'list']);
  }
}
